import React from 'react'
import Link from 'next/link'
import cn from 'classnames'

import styles from './btnCall.module.scss'
import { handleCall } from './handlers'

import { ButtonCallProps } from './types'

export default function ButtonCall({ special }: ButtonCallProps) {
  return (
    <Link href="tel:+1-888-488-7203" passHref className={styles.call}>
      <button
        onClick={() => handleCall()}
        className={cn({ [styles.btnCall]: true, [styles.special]: special })}
      >
        <img
          src="/home/phone-black.svg"
          className={styles.imgCall}
          width={25}
          height={25}
          alt="phone icon"
        />
        <div className={styles.containerText}>
          <span className={styles.title}>Call: 1 (888) 488-7203</span>
          <span className={styles.subtitle}>Mon-Sat 9a-9p ET</span>
        </div>
      </button>
    </Link>
  )
}
